import ModalFilter from '@components/modal-filter/modal-filter.component'
import { Selector } from '@hub/shared'
import { SectionCampaignInterface } from '@src/pages/home-campaign/home-campaign.page'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  filterOptions: SectionCampaignInterface[]
  onChange?: (value: any) => any
  checkboxType?: 'checkbox' | 'radio'
}

export default ({ filterOptions, onChange, checkboxType = 'checkbox' }: Props) => {
  const [t] = useTranslation('campaignModalFilter')
  const [openModal, setOpenModal] = useState(false)

  const handleChange = useCallback(
    (name, value: boolean) => {
      if (onChange && typeof onChange === 'function') {
        onChange({ [name]: value })
      }
    },
    [onChange]
  )

  const closeModal = () => {
    setOpenModal(false)
  }

  return (
    <ModalFilter
      className="campaign-modal-filter-body"
      header={t('filters')}
      open={openModal}
      closeModal={(value) => closeModal()}
      openModal={(value) => setOpenModal(value)}
    >
      <h6 key="campaign-filter-selector-title" className="campaign-filter-selector-title mt-3">
        {t('campaignTypes')}
      </h6>

      {filterOptions?.map((option, index) => (
        <Selector
          key={`campaign-filter-selector-option-${option?.value}-${index}`}
          name="campaign-filter-selector-option"
          id={`campaign-filter-selector-option-${option?.value}-${index}`}
          wrapperClass="justify-content-space-between mb-3"
          value={option?.show}
          checked={option?.show}
          onChange={(value) => handleChange(option?.value, value)}
          type={checkboxType}
          errorSpan={false}
          leftLabel={
            <div className="display-flex">
              <i
                className={`mr-2 ${option?.value === 'invited' ? 'fa-solid fa-crown' : option?.icon}`}
                style={{ width: 22, fontSize: 18 }}
              ></i>
              <span className="campaign-filter-selector-text">{t(option?.value)}</span>
            </div>
          }
        />
      ))}
    </ModalFilter>
  )
}
